<!--
	作者：masonchen
	时间：2017-08-22
	描述：轨迹回放 -> 主面板 -> 救援轨迹回放 子组件
-->
<template>
	<li :class="itemClass" v-loading="loadingEx" element-loading-text="导出中">
		<dl>
			<dt>
	            <p>
	              <input v-if="data.lockFlg !== 1" type="checkbox" v-model='isChecked'>
	              <span>
	              	<a v-show="data.lockFlg==1" class="ico_01a" 
	              		@click="clickLock(data.lockFlg,data.id)" 
	              		data-toggle="tracetip" 
	              		data-placement="bottom" title="解锁">
	              	</a>
	              	<a v-show="data.lockFlg!=1" class="ico_01b" 
	              		@click="clickLock(data.lockFlg,data.id)" 
	              		data-toggle="tracetip" 
	              		data-placement="bottom" title="锁定">
	              	</a>
				    </span>
				    <span class="sp_text">{{data.vehicleInfo.ownerName}}</span>
				    <i @click="checkTrack" data-toggle="tracetip" 
				      	data-placement="bottom" title="查看">
				      	<a class="ico_02"></a>
				    </i>
				    <i @click="exportTrack"
				    	data-toggle="tracetip" 
				      	data-placement="bottom" title="导出">
				      	<a class="ico_04">
				      		<img src="../../../../assets/project/images/map/map_icon_56.png"/>
				      	</a>
				    </i>
	            </p>
	            <p><em>{{data.vehicleInfo.plateNumber}}</em><b>{{data.vehicleInfo.rescueVehicleType}}</b></p>
			</dt>
			<dd>
				<a class="noLink">救援轨迹回放</a><em>{{data.rescueOrderId}}</em></dd>
		</dl>
		<div class="date">
			<p>
				<span>接单时间：{{data.rescueOrderTime}}</span>
			</p>
		</div>
	</li>
</template>

<script>
	import { mapState } from 'vuex'
	import { Mixin } from './mixin'
	import { comMixin } from 'util/util.js'
	export default {
		mixins: [Mixin, comMixin],
		data() {
			return {
				isChecked: this.data.isChecked,
				traceCheckFlag: 0, //是否点击了查看轨迹
				dayNum: '',
				monNum: '',
				yearNum: '',
				dateStr: '',
				loadingEx: false,
				itemClass:'bgc_orange'
			}
		},
		props: {
			data: {
				type: Object,
				default() {
					return {}
				}
			},
			checked: {
				type: Boolean
			}
		},
		computed: {
			...mapState({
//				newDay: state => state.vehicle.newDay,
//				hasTrackDay: state => state.vehicle.hasTrackDay,
//				carId: state => state.vehicle.carId,
				traceListInfo:state=>state.vehicle.traceListInfo,//从轨迹队列接口获取的队列列表对象
				userId: state => state.user.userId,
				vehiInfo:state => state.vehicle.vehiInfo
			})
		},
		watch: {
//			data: {
//				handler: function(val) {
//					this.dateStr = val.gpsTime.split(' ')[0] || '-';
//				},
//				deep: true
//			},
			vehiInfo:{
				handler: function(val){
					if(val && val.vId){
						if(val.vId === this.data.id){
							this.itemClass="bgc_orange active";
						} else {
							this.itemClass="bgc_orange";
						}
					}
				},
				deep:true
			}
		},
		mounted() {
//			this.dateStr = this.data.gpsTime.split(' ')[0] || '-';
			this.autoShowTrack(this.traceListInfo.list)
		},
		methods: {
			// 当前待查看轨迹的车辆为1辆时，跳转到车辆轨迹功能时，需要自动显示出轨迹
			// 调整为 第一条未锁定的轨迹自动显示
			autoShowTrack(list){
				let firstTrace = "";
				for(let i = 0; i < list.length; i++){
					const type = list[i].showType; 
					if(type == '4' || type == '3' || type == '10'){
						firstTrace = list[i];
						break;
					}
				}
				this.itemClass="bgc_orange";
				if(!firstTrace) return;
				if(firstTrace.lockFlg === 1) return;
				if(firstTrace.id === this.data.id) {
					this.checkTrack();
					this.itemClass="bgc_orange active";
				}
			},
			exportTrack() {
				this.loadingEx = true
				//if 有轨迹下 TODO：
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/trace/traces/rescue/export/' + this.data.id)
					.then((res) => {
						let str = res.body.data
						var path = process.env.EXPORT_PATH;
						var api = process.env.API_ROOT;
						var fileName = path + '/api/noauth/export?url=' + str + '&path=' + this.userId;
						var elemIF = document.createElement("iframe");
						elemIF.src = fileName;
						elemIF.style.display = "none";
						document.body.appendChild(elemIF);
						this.loadingEx = false
					}, (res) => {
						this.loadingEx = false
						const obj = {
							tipCnt: res.body.message,
							showBtn: false
						}
						this.$store.dispatch('showModal', obj);
					})
					.catch((res) => {
						this.loadingEx = false
						const obj = {
							tipCnt: res.body.message,
							showBtn: false
						}
						this.$store.dispatch('showModal', obj);
					})
			},
			checkTrack() {
				const self = this;
//				const trackObj = {
//					id: this.data.id,
//					showType: 5,
////					vehiInfo: this.data.vehicleInfo,
//					vehiInfo: {
//						ownerName:"青岛迪迪",
//						plateNumber:"鲁B00001",
//						vehicleNum:"1064623477541"
//					},
//					uni: new Date().getTime()
//				}
				const trackObj = {
					id:this.data.id,
					showType:this.data.showType,
					vehiInfo:this.data.vehicleInfo,
					uni:new Date().getTime()
				}
				this.$store.dispatch('getRescueTrack', trackObj);
			}
//			getDateStr(str) { //2017-04-09=>20170409
//				const y = str.split('-')[0]
//				const m = str.split('-')[1]
//				const d = str.split('-')[2]
//				return y + m + d
//			}
		}
	}
	// 对Date的扩展，将 Date 转化为指定格式的String
	// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
	// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
	// 例子： 
	// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
	// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 
	Date.prototype.Format = function(fmt) {
		var o = {
			"M+": this.getMonth() + 1, //月份 
			"d+": this.getDate(), //日 
			"h+": this.getHours(), //小时 
			"m+": this.getMinutes(), //分 
			"s+": this.getSeconds(), //秒 
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度 
			"S": this.getMilliseconds() //毫秒 
		};
		if(/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		for(var k in o)
			if(new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
		return fmt;
	}

	function timeToSec(str) {
		//	let str = num + ''
		//let sec = 0;
		let h = parseInt(str.substring(6, 8));
		let m = parseInt(str.substring(8, 10));
		let s = parseInt(str.substring(10));
		//let totalSec = 0;
		return h * 3600 + m * 60 + s;
	}
</script>


// WEBPACK FOOTER //
// VehicleItemRescue.vue?2f9850e0